import {ContentItem, WidgetContentItemsState} from "@/store/general/widget-content-items/state";
import {MutationTree} from "vuex";

export const SET_CONTENT_ITEMS_WIDGET = 'setContentItemsWidget';

const mutations: MutationTree<WidgetContentItemsState> = {
    [SET_CONTENT_ITEMS_WIDGET](state: WidgetContentItemsState, contentItems: ContentItem[]) {
        state.widgetContentItems.contentItems = contentItems;
    }
}

export default mutations;
